import { SortOrder } from '@iotv/iotv-v3-types';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
import { flattenArray, sortByTimestamp } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export const getNextMessages = async ({ QueryExecutionId, NextToken: NextTokenIn, transformType }) => {
    const path = `/bi/nextResults`;
    const params = { QueryExecutionId, NextToken: NextTokenIn, transformType };
    debug && console.log('INFO: getNextMessages posting', { path, params });
    let res = { err: null, data: null };
    const { err, data, NextToken } = (await ApiGateway.post(path, params, 'NetworkApi'));
    if (err) {
        console.log('getNextMessages err', err.message);
        res.err = err;
    }
    if (NextToken) {
        res.NextToken = NextToken;
        res.QueryExecutionId = QueryExecutionId;
    }
    if (data) {
        debug && console.log('getNextMessages data', data);
        debug && console.log('getNextMessages nextToken?', res.NextToken);
        debug && console.log('getNextMessages QueryExecutionId?', res.QueryExecutionId);
        //2026 04 currentlythis will only work with device messages!!
        const flatMessages = flattenArray(data).sort((a, b) => sortByTimestamp(a, b, SortOrder.DESCENDING));
        res.data = flatMessages;
    }
    return res;
};
